import React from 'react';
import classes from './RadioButton.module.css';
import { Form } from 'react-bootstrap';
const RadioButton = ({ setter, value, selected, name, id, label, disabled }) => {
  const onChange = (e) => {
    if (typeof setter === 'function') {
      setter(e.target.value);
    }
  };

  return (
    <Form.Check
      disabled={disabled}
      className={classes.radio}
      label={label}
      name={name}
      type="radio"
      id={id}
      value={value}
      checked={selected}
      onClick={onChange}
    />
  );
};

export default RadioButton;
